<template>
  <div class="infor_input1">
    <ul>
      <li class="second_li">
        <b>入住人数：</b>
        <el-input-number v-model="hotelData.adult" size='mini' :min="0" label="成人"></el-input-number>
        &nbsp;&nbsp;成人&nbsp;&nbsp;
        <el-input-number v-model="hotelData.children" size='mini' :min="0" label="儿童"></el-input-number>
        &nbsp;&nbsp;儿童&nbsp;&nbsp;
      </li>
      <li class="second_li">
        <b>您想要的酒店：</b>
        <el-select v-model="hotelData.star" placeholder="请选择星级" size="mini">
          <el-option v-for="item in hoteloptionsOne" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-select v-model="hotelData.location" placeholder="请选择位置" size="mini" style="margin-left: 0.45rem;">
          <el-option v-for="item in hoteloptionsTwo" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </li>
      <li class="three_li">
        <b>您需要的房型和数量：</b>
        <i class="el-icon-circle-plus-outline" @click="addRoomData"></i>
        <el-radio-group v-model="hotelData.breakfast" style="margin-left:10px;">
          <el-radio label="含早">含早餐</el-radio>
          <el-radio label="不含早餐">不含早餐</el-radio>
          <el-radio label="含不含早都可以">含不含早都可以</el-radio>
        </el-radio-group>
      </li>
      <li class="four_li">
        <ul>
          <li v-for="(room,ind) in hotelData.hotelRoomList" :key="ind">
            <el-select v-model="room.hotelRoomName" placeholder="请选择房型" size="mini" @change="chooseRoom($event,room)">
              <el-option v-for="item in roomTypeOption" :key="item.id" :label="item.categorySonNameCn+' ('+item.categorySonDiscreb+')'"
                :value="item">
              </el-option>
            </el-select>
            <el-input v-model="room.roomNumber" placeholder="间数" size="small" style="width: 0.6rem;margin-left:0.1rem"
                      @input="room.roomNumber=room.roomNumber.replace(/[^\d]/g,'')"></el-input>&nbsp;&nbsp;间&nbsp;
            <el-input v-model="room.roomBudget" placeholder="锁死预算/间" style="width: 1.4rem;" size="small"
                      @input="room.roomBudget=room.roomBudget.replace(/[^\d]/g,'')"></el-input>
            <currency-autocomplete :obj="room" :styleStr="'width: 0.8rem;margin-left:0.1rem; margin-right: 0.1rem;'"></currency-autocomplete>
            <i class="el-icon-question"></i>
            <i class="el-icon-remove-outline" @click="delOneData(ind,hotelData.hotelRoomList)" v-if="hotelData.hotelRoomList.length>1"></i>
          </li>
        </ul>
      </li>
      <li>
        <b>您的备注：</b>
        <el-input v-model="hotelData.remarks" placeholder="您还有其他什么特别要求？" style="width: 4.05rem;"
          size="small"></el-input>
      </li>
    </ul>
  </div>
</template>

<script>
import CurrencyAutocomplete from '../../common/currencyAutocomplete.vue'
import Api from '@/components/Api/index.js'
import CityAutocomplete from "../../common/cityAutocomplete";
export default {
  components:{CityAutocomplete, CurrencyAutocomplete},
  props:{
    hotelData:{
      type:Object,
      default:()=>{return {}}
    },
  },
  data(){
    return{
      hoteloptionsOne: ["三星酒店","四星酒店","五星酒店"],
      hoteloptionsTwo: ["市中心","市区就可以","靠近地铁"],
      roomTypeOption: [],
    }
  },
  methods:{
    addRoomData () {
      this.hotelData.hotelRoomList.push({
        hotelRoomName: '',
        roomNumber: '',
        roomBudget: '',
        currency: '',
      })
    },
    chooseRoom(obj,obj1){
      this.$set(obj1,'hotelRoomName',obj.categorySonNameCn)
      this.$set(obj1,'hotelRoomNameEn',obj.categorySonNameEn)
    },
    delOneData(index,arr){
      arr.splice(index,1)
    },
    getRoomType () {
      let obj = {
        page: 1,
        q: {
          molds:[10]
        },
        size: 100
      }
      new Api('resource').getResourceType(obj).then(res => {
        if (res.status == 200) {
          this.roomTypeOption = res.data.records
        }
      })
    },
  },
  mounted(){
    this.getRoomType();
  }
}
</script>

<style lang="scss" scoped>
.infor_input1{
  ul{
    li{
      margin: 0.15rem 0;
    }
    .second_li b {
      display: inline-block;
      width: 100px;
    }
    /deep/ .el-input-number--mini{
      width: 1.2rem;
      line-height: 0.3rem;
    }
    /deep/ .el-input-number__increase{
      height: 0.3rem;
    }
    /deep/ .el-select{
      width: 1.2rem;
    }
    /deep/ .el-input__inner{
      padding: 0 0.15rem !important;
    }
    i{
      font-size: 0.26rem;
      font-weight: bold;
      vertical-align: middle;
      cursor: pointer;
    }
    /deep/ .el-radio{
      margin-right: 0.1rem;
    }
    /deep/ .el-radio__label{
      padding-left: 0.1rem;
      font-size: 0.12rem;
    }
  }
}
</style>